<template>
  <v-container fluid :class="currentEvent == null ? 'fill-height' : ''">
    <v-row v-if="currentSponsor == null">
      <v-col>
        <Loading/>
      </v-col>
    </v-row>
    <v-row align="center" v-else justify="center" class="mx-0">
      <v-col cols="12">
        <v-breadcrumbs :items="breadCrumbItems" large>
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
                :disabled="item.disabled"
                :class="[
                'text-capitalize px-0',
                {
                  'cursor-pointer':
                    item.routeName != $route.name && !item.disabled,
                },
              ]"
                @click="handleRoute(item)"
            >
              <div
                  :class="[
                  item.routeName != $route.name && !item.disabled
                    ? 'primary--text'
                    : 'grey--text',
                  'text-subtitle ',
                ]"
              >
                {{ item.text }}
              </div>
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </v-col>
      <v-col cols="12">
        <v-card outlined min-height="110vh" class="px-8 py-4">
          <v-card-title>{{
              currentSponsor.name
            }}
          </v-card-title>
          <v-card-text>
            <template>
              <v-tabs v-model="tab"
                      active-class="primary--text"
              >
                <v-tab active-class="primary--text" class="text-capitalize" v-for="item in items" :key="item.tab">
                  {{ item.text }}
                </v-tab>
              </v-tabs>
              <v-divider></v-divider>
              <v-row>
                <v-col :cols="tab == 0 || tab == 1 ? `6` : `12`">
                  <v-tabs-items v-model="tab">
                    <v-tab-item v-for="item in items" :key="item.tab">
                      <component v-bind:is="item.content" :currentSponsor="currentSponsor"></component>
                    </v-tab-item>
                  </v-tabs-items>
                  <v-btn
                      v-if="tab==2 && !isSponsorRepJoined"
                      width="150"
                      color="primary"
                      depressed
                      large
                      class="text-body-1 fixed btn"
                      :disabled="isSaveDisabled"
                      @click="handleSave">
                    Save
                  </v-btn>
                  <v-btn
                      v-if="tab==2 && currentSponsor.email && isGrantAccessDataValid && !isSponsorRepJoined"
                      width="150"
                      color="primary"
                      outlined
                      depressed
                      large
                      class="text-body-1 fixed btn ml-4"
                      :disabled="isSaveDisabled"
                      @click="sendSponsorRepresentativeInvitationEmail">
                    Send Invite
                  </v-btn>
                </v-col>
                <v-col cols="6" v-if="tab==0 || tab==1" >
                  <div class="float-right parent">
                    <v-row align="end" justify="end" class="py-8 pr-4">
                      <v-btn
                          width="150"
                          color="primary"
                          depressed
                          large
                          class="text-body-1 fixed btn"
                          :disabled="isSaveDisabled"
                          @click="handleSave">
                        Save
                      </v-btn>
                    </v-row>
                    <SponsorPreview :sponsor="currentSponsor"
                                    height="480"
                                    maxHeight="480"
                                    :tab="0"
                    />
                  </div>
                </v-col>
              </v-row>

            </template>
          </v-card-text>

        </v-card>

      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import Loading from "@/components/Loading";
import {mapGetters, mapActions} from "vuex";

import Sponsor from "@/models/Sponsor";
import Event from "@/models/Event";
import EditSponsorDetails from "@/components/MultiConnect/Sponsors/EditSponsorDetails.vue";
import EditSponsorSocials from "@/components/MultiConnect/Sponsors/EditSponsorSocials.vue";
import EditPersonInCharge from "@/components/MultiConnect/Sponsors/EditPersonInCharge.vue";
import ManageRepresentatives from "@/components/MultiConnect/Sponsors/ManageRepresentatives.vue";
import SponsorPreview from "@/components/MultiConnect/Sponsors/SponsorPreview.vue";
import Preview from "@/components/LinkInBio/Preview.vue";
import {eventDocRef, getDocRef, getHttpsCallable} from "@/shared/firebase_utils";
import {onSnapshot} from "firebase/firestore";

export default {
  created() {
    this.eventId = this.$route.params.eventId;
    this.sponsorId = this.$route.params.sponsorId;
    this.promoterType = this.$route.query.promoterType;
    let tab = this.$route.query.tab;
    try {
      //Get event doc from firestore

      this.unsubscribeEventsSnapshot = onSnapshot(
              eventDocRef(this.eventId),
              async (documentSnapshot) => {
            //Event exists in firestore
            if (documentSnapshot.data() != undefined) {
              let newEvent = Event.fromFireStore(documentSnapshot);
              this.currentEvent = newEvent;
            } else {
              console.log("event document does not exist in Fs");
            }
          });


      let collectionName = this.promoterType == "STARTUPS_AND_SCALE_UPS" ? "featuredCompanies" : "sponsors";
      /// Get the sponsor doc
      this.unsubscribeSponsorSnapshot = onSnapshot(
              getDocRef(collectionName, this.sponsorId),
              (querySnapshot) => {
            this.currentSponsor = Sponsor.fromObject(querySnapshot.data());
          });
    } catch (error) {
      console.error(
          "Error occurred while fetching snapshot of events for super user: ",
          error
      );
    }
  },
  components: {
    Preview,
    SponsorPreview,
    Loading
  },
  computed: {
    ...mapGetters(["businessProfile", "currentSubEvent"]),
    isSaveDisabled() {
      return false;
    },

    isSponsorRepJoined() {
      return this.currentSponsor.status === "Registered" || this.currentSponsor.status === "Onboarded";
    },

    isGrantAccessDataValid() {
      if (
        this.currentEvent && 
        this.currentSponsor &&
        this.currentSponsor.email &&
        this.currentSponsor.firstName &&
        this.currentSponsor.lastName &&
        this.isValidEmail(this.currentSponsor.email)
      ) {
        return true;
      } else {
        return false;
      }
    },

    breadCrumbItems() {
      if (this.currentEvent && this.currentSponsor) {
        let currentRouteName = this.currentSponsor.name
        let items = [
          {
            text: "EventConnect",
            disabled: false,
            routeName: "MultiConnect",
            params: "",
          },
          {
            text: this.currentEvent.name,
            disabled: false,
            routeName: "editMultiConnect",
            params: {eventId: this.currentEvent.id},
            query: {tab: 1}
          },
          {
            text: currentRouteName,
            disabled: true,
            routeName: "editSponsor",
            params: {
              eventId: this.currentEvent.id,
              sponsorId: this.currentSponsor.sponsorDocRef,
            },
          },
        ];
        return items;
      } else return [];
    }
  },

  data() {
    return {
      eventId: "",
      sponsorId: "",
      currentEvent: null,
      currentSponsor: null,
      unsubscribeEventsSnapshot: null,
      unsubscribeSponsorSnapshot: null,
      tab: 0,
      items: [
        {tab: 0, text: 'Info', content: EditSponsorDetails},
        {tab: 1, text: 'Contact & Socials', content: EditSponsorSocials},
        {tab: 2, text: 'Grant Access', content: EditPersonInCharge},
        {tab: 3, text: 'Representatives', content: ManageRepresentatives},
      ],
      promoterType: "",
    }
  },
  methods: {
    ...mapActions(["showSnackbar"]),
    handleRoute(item) {
      if (!item.disabled) {
        let route = {name: item.routeName, params: item.params};
        if (item.query) {
          route.query = item.query;
        }
        this.$router.push(route);
      }
    },
    
    // Function to check if email is valid
    isValidEmail(email) {
      // Regular expression to validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    
    async handleSave() {
      this.currentSponsor.isReviewed = true;

      let isSponsorAdded = false;
      let sponsorRef = await this.currentSponsor.save();
      this.currentSponsor.sponsorDocRef = sponsorRef;

      if (this.promoterType == "STARTUPS_AND_SCALE_UPS") { 
         //Update the featuredCompanies in the current event array
         let index = this.currentEvent.featuredCompanies.findIndex(
            (sponsor) => sponsor.uid == this.currentSponsor.uid
        );
        this.currentEvent.featuredCompanies.splice(index, 1, this.currentSponsor);
      } else {
        //Update the sponsor in the current event array
        let index = this.currentEvent.sponsors.findIndex(
            (sponsor) => sponsor.uid == this.currentSponsor.uid
        );
        this.currentEvent.sponsors.splice(index, 1, this.currentSponsor);
      }
      this.currentEvent.save();

      this.showSnackbar({show: true, text: "Updated successfully!"});
    },

    async sendSponsorRepresentativeInvitationEmail() {
    // Prepare the data required for the cloud function
    const data = {
      email: this.currentSponsor.email,
      firstName: this.currentSponsor.firstName,
      eventName: this.currentEvent.name,
      sponsorId: this.sponsorId,
      hostName: this.currentEvent.hostName,
      promoterType: this.promoterType,
    };
    try {
      const sendSponsorRepresentativeInvitationEmail = getHttpsCallable("sendSponsorRepresentativeInvitationEmail");

      this.showSnackbar({ show: true, text: "Sending invitation email...", timeout: 0 });
      //Call the cloud function
      await sendSponsorRepresentativeInvitationEmail(data);

      this.showSnackbar({ show: true, text: "Invitation email sent!" });
    } catch (error) {
      console.error("Error sending invitation email:", error);
      this.showSnackbar({ show: true, text: "Failed to send invitation email" });
    }
  },

  }

}
</script>